import CardSystem, { getCardHandler } from '../CardSystem';
import AnimationTask from '../../../Utility/Task/AnimationTask';
import Renderable from '../../../Component/Renderable';
import TransformComponent from '../../../Component/Transform';
import BaseCardHandler from '../Handler/BaseCardHandler';
import Interactable from '../../../Component/Interactable';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function UndoMatchCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    const card = system.getCardByID(taskData.cards[0]);
    const transform = card.getComponent(TransformComponent);

    // Re-position card.
    system.stackContainer.addChild(card);
    transform.position.set(0);
    transform.rotation = 0;
    system.cardsContainer.addChild(card);

    // Set face-up.
    const handler: BaseCardHandler = getCardHandler(card);
    handler.setCardFaceUp(true);

    // Show next top card folded if any.
    const cardsFolded = system.getCardsFolded();
    const topCardFolded = cardsFolded[cardsFolded.length - 1];
    if (topCardFolded) {
        topCardFolded.getComponent(Renderable).visible = true;
    }

    const cardInteractable = card.getComponent(Interactable);

    cardInteractable.enabled = true;
    cardInteractable.buttonMode = true;
    system.taskQueue.queue(
        new AnimationTask('UndoMatch', card, undefined, true)
    );
}
